import React from 'react';
import PropTypes from 'prop-types';
import Button from '@strava/ui/Button';
import { typography } from '@strava/ui-tokens/js';

const CTA = ({ children, onClick, ...props }) => {

  return (
    <Button
      variant="primary"
      onClick={() => {
        onClick();
      }}
      style={{ fontWeight: typography.fontWeightDemi }}
      {...props}
    >
      {children}
    </Button>
  );
};

CTA.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
};


export default CTA;
